module.exports = __webpack_public_path__ + "media/images/captive_portal/facebook-99b8c65e568aa1cb1a36039542425bee.svg";